import { configureStore } from "@reduxjs/toolkit";
import UserSlice from "./Slices/UserSlice";
import AudioSlice from "./Slices/AudioSlice";
import SoundPlayerSlice from "./Slices/SoundPlayerSlice";
import MixerSlice from "./Slices/MixerSlice";
import MyMixerSlice from "./Slices/MyMixerSlice";
import ExternalMixerSlice from "./Slices/ExternalMixerSlice";
import APIs from "./Slices/APIs";
import SaveMixSlice from "./Slices/SaveMixSlice";
import PlayerSlice from "./Slices/PlayerSlice";
import PlaylistSlice from "./Slices/PlaylistSlice";
import ModalSlice from "./Slices/ModalSlice";
import LanguageSlice from "./Slices/LanguageSlice";
import TimerSlice from "./Slices/TimerSlice";

const store = configureStore({
    reducer: {
        user: UserSlice,
        audio: AudioSlice,
        soundPlayer: SoundPlayerSlice,
        mixer: MixerSlice,
        mymixer: MyMixerSlice,
        externalmixerslice: ExternalMixerSlice,
        APIS: APIs,
        mixStatus: SaveMixSlice,
        player: PlayerSlice, // To be removed later
        playlist: PlaylistSlice,
        modal: ModalSlice,
        language: LanguageSlice,
        timer: TimerSlice,
    }
})

export default store